import fetchValuation from '../Services/fetchValuation';

export default () => async (dispatch) => {
  dispatch(fetchValuation());
}